<template>
  <div class="user">
    <!--添加等级-->
    <!-- <div class="common-level-rail">
        <el-button size="small" type="primary" @click="addClick" v-auth="'/fengkong/operation/add'">添加</el-button>
      </div> -->

    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="姓名">
          <el-input v-model="searchForm.user_name" placeholder="请输入真实姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="searchForm.user_phone" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="身份证">
          <el-input v-model="searchForm.user_id_code" placeholder="请输入身份证"></el-input>
        </el-form-item>
        <el-form-item label="起始时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker size="small" v-model="searchForm.create_time" type="daterange" value-format="yyyy-MM-dd"
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item><el-button size="small" type="primary" icon="el-icon-search"
            @click="onSubmit">查询</el-button></el-form-item>
        <!-- <el-form-item><el-button size="small" type="success" @click="onExport">导出</el-button></el-form-item>
        <el-form-item><el-button size="small" type="info" @click="getshuax">刷新</el-button></el-form-item> -->
      </el-form>
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="id" label="ID"></el-table-column>
          <el-table-column prop="user_name" label="真实姓名"></el-table-column>
          <el-table-column prop="user_id_code" label="身份证号码"></el-table-column>
          <el-table-column prop="user_phone" label="手机号"></el-table-column>
          <el-table-column prop="report_type" label="百融风控类型(1 信息查询 2 贷前策略)" width="280"></el-table-column>
          <el-table-column prop="score" label="综合评分"></el-table-column>
          <el-table-column prop="proposal" label="建议"></el-table-column>
          <el-table-column prop="create_time" label="添加时间"></el-table-column>
          <el-table-column fixed="right" label="操作" width="120">
            <template slot-scope="scope">
              <el-button @click="editClick(scope.row)" type="text" size="small">风控报告</el-button>
              <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
          :current-page="curPage" :page-sizes="[10, 20, 50, 100]" :page-size="10"
          layout="total, sizes,prev, pager, next, jumper" :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>

  </div>
</template>
  
<script>
import FengkongApi from '@/api/fengkong.js';
export default {
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      formInline: {
        user: '',
        region: ''
      },
      /*横向表单数据模型*/
      searchForm: {
        user_name: '',
        user_phone: '',
        user_id_code: '',
        order_no: '',
        style_id: '',
        create_time: ''
      },
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {}
    };
  },
  created() {

    /*获取列表*/
    this.getData();

  },
  methods: {
    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.tableData = [];
      this.getData();
    },

    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },

    /*获取列表*/
    getData() {
      let self = this;
      let Params = self.searchForm;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      FengkongApi.riskList(Params, true)
        .then(data => {
          self.loading = false;
          console.log(data.data.list.data);
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total
        })
        .catch(error => {

        });
    },
    /*打开添加*/
    addClick() {
      this.$router.push('/fengkong/operation/add');
    },

    /*打开编辑*/
    editClick(item) {
      console.log(item.id);
      // console.log(item.risk_text);
      // let str = item.risk_text;
      // console.log("风控",JSON.parse(str));
      this.$router.push({
        path: '/riskmanagement/risk/details',
        query: {
          id: item.id
        }
      })


    },

    /*删除用户*/
    deleteClick(row) {
      let self = this;
      self.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        self.loading = true;
        FengkongApi.riskDelete({
          id: row.id
        }, true).then(data => {
          self.loading = false;
          self.$message({
            message: data.msg,
            type: 'success'
          });
          self.getData();
        })
          .catch(error => {
            self.loading = false;
          });

      }).catch(() => { });
    }

  }
};
</script>
  
<style>
.tips {
  color: #ccc;
}
</style>


// WEBPACK FOOTER //
// src/views/riskmanagement/risk/list.vue